'use client';

import { recordImpression } from '@/actions/public/server.actions';
import { nonProfitApplicationStatus } from '@/actions/server.actions';
import JoinNonProfitButton from '@/components/next-page-components/JoinNonProfitButton';
import ShareButton from '@/components/next-page-components/ShareButton';
import useUserProfile from '@/hooks/useUserProfile';
import { isDonateDisabled } from '@/utils/donate.helper';
import { getEnvBaseUrl } from '@/utils/stringHelpers';
import DonateButton from '@components/DonateButton';
import StripeDonateButton from '@components/StripeDonateButton';
import Button from '@ui/Button';
import React, { useEffect, useState } from 'react';

function HeaderButtons({ nonProfit, slug }) {
  const user = useUserProfile();
  const [applicationExists, setApplicationExists] = useState({});

  let recordDonationClickPayload = {
    type: 'nonprofit_public_page',
    nonProfitId: nonProfit.id,
    donationClick: {
      userId: user?.id,
      activeCommunityId: user?.activeCommunity?.id,
      location: user?.location,
    },
  };

  const getClaimUrl = () => {
    const baseUrl = getEnvBaseUrl('admin');
    return `${baseUrl}/nonprofit/sign-up?name=${nonProfit.name}&country=${nonProfit.country}`;
  };

  const getApplicationStatus = async () => {
    const data = await nonProfitApplicationStatus(user?.email, nonProfit?.id);
    setApplicationExists(data);
  };

  useEffect(() => {
    getApplicationStatus();
  }, [slug]);

  const renderDonateButton = () => {
    const disabled = !nonProfit?.isClaimed || isDonateDisabled(user, nonProfit);
    if (disabled) {
      return;
    }
    return (
      <StripeDonateButton
        nonProfit={nonProfit}
        recordPayload={recordDonationClickPayload}
      />
    );
  };

  return (
    <div className="flex gap-4 self-end px-6 lg:self-start lg:pl-0 lg:pr-4">
      {nonProfit?.isClaimed ? (
        <JoinNonProfitButton
          nonProfit={nonProfit}
          pendingApproval={applicationExists?.status === 'pending'}>
          Join
        </JoinNonProfitButton>
      ) : (
        <Button
          as="a"
          variant="filled"
          color="primary"
          href={getClaimUrl()}
          target="_blank">
          Claim
        </Button>
      )}

      {/* <JoinNonProfitButton
        nonProfit={nonProfit}
        pendingApproval={applicationExists?.status === 'pending'}>
        Join
      </JoinNonProfitButton> */}

      {renderDonateButton()}
    </div>
  );
}

export default HeaderButtons;
